document.addEventListener("DOMContentLoaded", () => {

    // Les SVG sont servis avec un cache d'un an (edge Cloudflare + navigateur).
    // Incrémenter cette version à chaque modification d'une icône météo, sinon
    // l'ancien fichier continue d'être servi pendant des mois.
    const ICON_VERSION = 2;

    if (document.getElementById('weatherIcon')) {
        const url = `https://api.openweathermap.org/data/2.5/weather?q=Redange,LU&units=metric&appid=8ae183d4d7bdf164954fa72bf1114ba7`;
        fetch(url)
            .then(response => {
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                return response.json();
            })
            .then(data => {
                const weather = data.weather[0].main;
                const temp = data.main.temp;
                let iconUrl = '';

                if (weather === 'Rain' || weather === 'Drizzle' || weather === 'Thunderstorm') {
                    iconUrl = '/dist/images/weather/cloud-rain.svg';
                } else if (weather === 'Clouds') {
                    iconUrl = '/dist/images/weather/cloud-sun.svg';
                } else if (weather === 'Snow') {
                    iconUrl = '/dist/images/weather/cloud-snow.svg';
                } else if (weather === 'Clear') {
                    iconUrl = '/dist/images/weather/sun.svg';
                } else {
                    iconUrl = '/dist/images/weather/cloud.svg';
                }

                document.getElementById('weatherIcon').setAttribute('src', `${iconUrl}?v=${ICON_VERSION}`);
                document.getElementById('weatherTemp').innerText = (Math.round(temp)) + '°C';

            })
            .catch(error => {
                // console.error('Error fetching the weather data:', error)
            });
    }
});
